<template>
  <div class="container_wrap">
    <div class="layout_main layout">
      <Breadcrumbs :title="computedTitle"></Breadcrumbs>
      <div class="categoryList">
        <div class="list clearfix"></div>
      </div>
      <div class="card_one Multiline">
        <div class="main_body">
          <div class="list" style="">
            <div class="item"><a class="img" target="_blank" href="https://org.ttcdw.cn/project/983123849693712384"
                title="山西省第三届家庭教育指导技能大赛"><img
                  src="https://rms.guorent.com/dev/upload/article/E41242DD9A797AAE81C11747099F7A0B/1746586007.jpg"></a>
              <div class="item_dl">
                <div style="display: block;" class="item_title"><a target="_blank"
                    href="https://org.ttcdw.cn/project/983123849693712384">山西省第三届家庭教育指导技能大赛</a></div>
              </div>
            </div>
            <div class="item"><a class="img" target="_blank" href="https://org.ttcdw.cn/project/903439760222658560"
                title="山西省第二届家庭教育指导技能大赛"><img
                  src="https://rms.guorent.com/dev/upload/article/67E9886063DE621C45B0EE002B0A7821/1730077091.png"></a>
              <div class="item_dl">
                <div style="display: block;" class="item_title"><a target="_blank"
                    href="https://org.ttcdw.cn/project/903439760222658560">山西省第二届家庭教育指导技能大赛</a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Breadcrumbs from './component/breadcrumb.vue';

export default {
  name: 'NetworkingIndex',
  components: {
    Breadcrumbs
  },
  data() {
    return {
      type: this.$route.params.type,
      // 数据可以根据实际需要进行调整
      items: [
        { title: '山西省第三届家庭教育指导技能大赛', link: 'https://org.ttcdw.cn/project/983123849693712384' },
        { title: '山西省第二届家庭教育指导技能大赛', link: 'https://org.ttcdw.cn/project/903439760222658560' }
      ]
    };
  },
  computed: {
    // 根据 type 动态计算标题
    computedTitle() {
      const titleMap = {
        0: '技能大赛',
        1: '大赛相关',

      };
      return titleMap[this.type];
    }
  },
  mounted() {
    document.title = '山西省第三届家庭教育指导技能大赛';
  }
};

</script>
<style lang="scss" scoped>
.container_wrap {
  width: 100%;
  min-width: 1200px;
  overflow: hidden;

  .layout_main {
    padding: 20px 0 30px 0;

    .categoryList {
      padding-top: 20px;
      margin-bottom: 10px;

      .clearfix:before,
      .clearfix:after {
        content: "";
        display: table;
      }

      .clearfix:after {
        visibility: hidden;
        display: block;
        font-size: 0;
        content: " ";
        clear: both;
        height: 0;
      }


    }

    .card_one {
      width: 100%;

      .main_body {
        padding-top: 30px;
        padding-bottom: 15px;



        .list {
          width: 120%;
          display: flex;
          flex-wrap: wrap;
        }
      }

      .item {
        margin-bottom: 30px;
        width: 290px;
        margin-right: 13px;

        a {
          display: block;
          position: relative;
          width: 100%;


        }

        .img {
          width: 290px;
          height: 162px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .item_dl {
          padding-top: 17px;

          .item_title a {

            height: 24px;
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: break-all;

          }

          .item_name {
            font-size: 14px;
            line-height: 20px;
            font-weight: 400;
            color: #999999;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: break-all;
          }

          .item_detail {
            max-height: 72px;
            margin-top: 4px;
            line-height: 24px;
            font-size: 14px;
            font-weight: 400;
            color: #505050;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
          }
        }

      }

      a {
        display: block;
        position: relative;
      }
    }
  }

  .layout {
    width: 1200px;
    margin: 0 auto;
  }
}
</style>